module.exports = __webpack_public_path__ + "img/comparison-logo-free.87a997d8.png";